import { ApiError } from '../../api/client'
import type { UsersTableRequest } from '../../api/settingsUsers'
import type { TableState } from '../../ui/DataTable'
import { dayMonthYear, stamp } from '../../inventoree/format'

/** Ce s-a intamplat, spus cu vorbele SERVERULUI cand le are. */
export function failed(error: unknown): string {
  return error instanceof ApiError && error.message ? error.message : 'Something went wrong.'
}

export function esc(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/** `moment(...).format('D MMM YYYY, HH:mm')`, ca in `UserEventsModel`. */
export function whenText(value: unknown): string {
  const when = stamp(value)
  if (!when) return ''
  const hh = String(when.getHours()).padStart(2, '0')
  const mm = String(when.getMinutes()).padStart(2, '0')
  return `${dayMonthYear(when)}, ${hh}:${mm}`
}

/** Cererea de lista, din starea tabelului. */
export function tableRequest(state: TableState, names: string[], fallback: string): UsersTableRequest {
  return {
    draw: 1,
    start: state.start,
    length: state.length,
    orderColumn: state.order.column,
    orderName: names[state.order.column] ?? fallback,
    orderDir: state.order.dir,
    search: state.search,
  }
}

/** Cele sapte zile ale unui plan, cu numele din `work_hours/plans/index.php`. */
export const WEEK_DAYS: { day: number; label: string }[] = [
  { day: 1, label: 'Monday' },
  { day: 2, label: 'Tuesday' },
  { day: 3, label: 'Wednesday' },
  { day: 4, label: 'Thursday' },
  { day: 5, label: 'Friday' },
  { day: 6, label: 'Saturday' },
  { day: 7, label: 'Sunday' },
]
